import { render } from "./MTextInputModal.vue?vue&type=template&id=105aee16"
import script from "./MTextInputModal.vue?vue&type=script&lang=ts"
export * from "./MTextInputModal.vue?vue&type=script&lang=ts"
script.render = render

export default script